const { serviceUrl } = require('core');

module.exports = function documentLink(id) {
    return serviceUrl('Timpex.Traffic.Trace.GetWayBill', { id: id });
}
